<template>
  <div class="reset-success-container">
    <div class="success-box">
      <div class="success-icon">
        <i class="icon-check"></i>
      </div>
      <h2>密码重置成功</h2>
      <p class="tip-text">请妥善保管您的账户信息</p>
      <button class="back-btn" @click="backToLogin">返回登录</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPasswordSuccess',
  methods: {
    backToLogin() {
      this.$router.replace('/login');
    },
  },
};
</script>

<style scoped>
.reset-success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f5f5;
  background-image: url(https://cqswsrc.xinan1.zos.ctyun.cn/ksbm/image/login-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.success-box {
  width: 400px;
  padding: 40px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.success-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background-color: #f0f9eb;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-check {
  font-size: 40px;
  color: #67c23a;
}

.icon-check::before {
  content: '✓';
}

h2 {
  color: #333;
  font-size: 24px;
  margin-bottom: 16px;
}

.tip-text {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
}

.back-btn {
  width: 100%;
  height: 40px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.back-btn:hover {
  background-color: #66b1ff;
}
</style>
